import PropTypes from 'prop-types';

export const props = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  hoverBkg: PropTypes.string,
  hoverColor: PropTypes.string,
  className: PropTypes.string,
};
